import React, { useEffect } from 'react';
import Icon from '../AppIcon';

const NotificationToast = ({ notification, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 'error':
        return {
          color: 'text-error',
          bgColor: 'bg-error/10',
          borderColor: 'border-error/30',
          icon: 'AlertCircle'
        };
      case 'warning':
        return {
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/30',
          icon: 'AlertTriangle'
        };
      case 'success':
        return {
          color: 'text-success',
          bgColor: 'bg-success/10',
          borderColor: 'border-success/30',
          icon: 'CheckCircle'
        };
      default:
        return {
          color: 'text-primary',
          bgColor: 'bg-primary/10',
          borderColor: 'border-primary/30',
          icon: 'Info'
        };
    }
  };

  const config = getSeverityConfig(notification?.severity);

  return (
    <div
      className={`fixed top-4 right-4 z-50 max-w-md w-full ${config?.bgColor} ${config?.borderColor} border rounded-lg shadow-lg p-4 animate-slide-in`}
    >
      <div className="flex items-start gap-3">
        <Icon name={config?.icon} size={20} className={config?.color} />
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground mb-1">{notification?.title}</h4>
          <p className="text-sm text-muted-foreground">{notification?.message}</p>
          {notification?.amount && (
            <p className="text-sm font-semibold text-foreground mt-1">
              ${notification?.amount?.toFixed(2)}
            </p>
          )}
        </div>
        <button
          onClick={onClose}
          className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    </div>
  );
};

export default NotificationToast;